// extracted by mini-css-extract-plugin
module.exports = {"link":"row_link__CKVHf","isActive":"row_isActive__3d17x"};